import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Truck,
  ShieldCheck,
  RotateCcw,
  Headphones,
  Zap,
  Shield,
  Activity,
  Award,
  ArrowRight,
  Mail,
  CheckCircle2
} from 'lucide-react';

import { getProductImageUrl } from '../../services/api';

const PreFooter = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
    }
  };

  return (
    <div style={{ background: '#ffffff', color: '#0f172a', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      
      {/* ============================================================
          PRE-FOOTER SECTION (MATCHING Z:\infraedge\above footer.png)
         ============================================================ */}
      <div className="prefooter-container" style={{ maxWidth: '1360px', margin: '0 auto', padding: '0 56px 64px' }}>
        
        {/* TOP GUARANTEE 4-CARD BAR */}
        <div style={{
          background: '#ffffff',
          border: '1px solid #e2e8f0',
          borderRadius: '16px',
          padding: '24px 36px',
          marginBottom: '48px',
          boxShadow: '0 4px 15px rgba(0,0,0,0.02)'
        }}>
          <div className="prefooter-guarantee-grid">
            
            <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
              <div style={{ width: '42px', height: '42px', borderRadius: '50%', background: '#fef2f2', color: '#dc2626', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <Truck size={20} />
              </div>
              <div>
                <h4 style={{ fontSize: '14px', fontWeight: 800, color: '#0f172a', margin: 0 }}>Free Shipping</h4>
                <span style={{ fontSize: '12px', color: '#64748b' }}>On all orders</span>
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
              <div style={{ width: '42px', height: '42px', borderRadius: '50%', background: '#fef2f2', color: '#dc2626', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <ShieldCheck size={20} />
              </div>
              <div>
                <h4 style={{ fontSize: '14px', fontWeight: 800, color: '#0f172a', margin: 0 }}>2 Year Warranty</h4>
                <span style={{ fontSize: '12px', color: '#64748b' }}>Peace of mind</span>
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
              <div style={{ width: '42px', height: '42px', borderRadius: '50%', background: '#fef2f2', color: '#dc2626', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <RotateCcw size={20} />
              </div>
              <div>
                <h4 style={{ fontSize: '14px', fontWeight: 800, color: '#0f172a', margin: 0 }}>60 Day Returns</h4>
                <span style={{ fontSize: '12px', color: '#64748b' }}>Hassle free</span>
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
              <div style={{ width: '42px', height: '42px', borderRadius: '50%', background: '#fef2f2', color: '#dc2626', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <Headphones size={20} />
              </div>
              <div>
                <h4 style={{ fontSize: '14px', fontWeight: 800, color: '#0f172a', margin: 0 }}>Dedicated Support</h4>
                <span style={{ fontSize: '12px', color: '#64748b' }}>We're here to help</span>
              </div>
            </div>

          </div>
        </div>

        {/* MIDDLE 3-COLUMN CONTENT BLOCK: "THE INFRAEDGE DIFFERENCE" */}
        <div className="prefooter-middle-grid">
          
          {/* Column 1: Image Stage */}
          <div style={{ position: 'relative', borderRadius: '20px', overflow: 'hidden', height: '340px', boxShadow: '0 12px 30px rgba(0,0,0,0.08)' }}>
            <img
              src="/hero_person_red_light_session_1787202717236.jpg"
              alt="Red Light Therapy Session"
              style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
            />
          </div>

          {/* Column 2: The InfraEdge Difference Content */}
          <div style={{ paddingRight: '12px' }}>
            <span style={{ fontSize: '11px', fontWeight: 900, letterSpacing: '0.15em', color: '#dc2626', textTransform: 'uppercase', display: 'block', marginBottom: '10px' }}>
              THE INFRAEDGE DIFFERENCE
            </span>

            <h2 style={{ fontSize: '36px', fontWeight: 900, color: '#0f172a', lineHeight: 1.15, marginBottom: '16px', letterSpacing: '-0.02em' }}>
              Engineered for Results.<br />
              Designed for You.
            </h2>

            <p style={{ fontSize: '14.5px', color: '#475569', lineHeight: 1.6, marginBottom: '28px' }}>
              Every InfraEdge panel is built with premium components and advanced technology to deliver powerful, consistent and safe red light therapy.
            </p>

            {/* 4 Feature Badges (2x2 Grid) */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
              
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: '#fef2f2', color: '#dc2626', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <Zap size={18} />
                </div>
                <div>
                  <h4 style={{ fontSize: '13.5px', fontWeight: 800, color: '#0f172a', margin: '0 0 2px 0' }}>Dual-Chip LEDs</h4>
                  <span style={{ fontSize: '11.5px', color: '#64748b' }}>Maximum efficiency</span>
                </div>
              </div>

              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: '#fef2f2', color: '#dc2626', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <Shield size={18} />
                </div>
                <div>
                  <h4 style={{ fontSize: '13.5px', fontWeight: 800, color: '#0f172a', margin: '0 0 2px 0' }}>Low EMF Output</h4>
                  <span style={{ fontSize: '11.5px', color: '#64748b' }}>Safe and reliable</span>
                </div>
              </div>

              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: '#fef2f2', color: '#dc2626', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <Activity size={18} />
                </div>
                <div>
                  <h4 style={{ fontSize: '13.5px', fontWeight: 800, color: '#0f172a', margin: '0 0 2px 0' }}>Flicker-Free Technology</h4>
                  <span style={{ fontSize: '11.5px', color: '#64748b' }}>Comfortable sessions</span>
                </div>
              </div>

              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: '#fef2f2', color: '#dc2626', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <Award size={18} />
                </div>
                <div>
                  <h4 style={{ fontSize: '13.5px', fontWeight: 800, color: '#0f172a', margin: '0 0 2px 0' }}>Aluminium Body</h4>
                  <span style={{ fontSize: '11.5px', color: '#64748b' }}>Built to last</span>
                </div>
              </div>

            </div>

          </div>

          {/* Column 3: Clinically Proven Technology Card */}
          <div style={{
            background: '#ffffff',
            border: '1px solid #e2e8f0',
            borderRadius: '20px',
            padding: '36px 28px',
            textAlign: 'center',
            boxShadow: '0 10px 25px rgba(0,0,0,0.03)'
          }}>
            <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: '#fef2f2', color: '#dc2626', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 18px' }}>
              <ShieldCheck size={32} />
            </div>

            <h3 style={{ fontSize: '20px', fontWeight: 900, color: '#0f172a', marginBottom: '10px' }}>
              Clinically Proven Technology
            </h3>

            <p style={{ fontSize: '13.5px', color: '#64748b', lineHeight: 1.5, marginBottom: '24px' }}>
              Trusted by athletes, wellness experts and thousands of happy customers.
            </p>

            <Link
              to="/about"
              style={{
                background: '#dc2626',
                color: '#ffffff',
                border: 'none',
                borderRadius: '12px',
                padding: '14px 24px',
                fontSize: '14px',
                fontWeight: 800,
                textDecoration: 'none',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                width: '100%',
                boxShadow: '0 8px 20px -4px rgba(220, 38, 38, 0.4)'
              }}
            >
              <span>Learn More About Us</span>
              <ArrowRight size={16} />
            </Link>
          </div>

        </div>

      </div>

      {/* RED NEWSLETTER BANNER BAR */}
      <div className="prefooter-newsletter-banner" style={{ background: '#dc2626', color: '#ffffff', padding: '24px 56px' }}>
        <div style={{ maxWidth: '1360px', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '20px' }}>
          
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', minWidth: 0 }}>
            <div style={{ width: '48px', height: '48px', borderRadius: '12px', background: 'rgba(255, 255, 255, 0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <Mail size={24} color="#ffffff" />
            </div>
            <div>
              <h3 style={{ fontSize: '18px', fontWeight: 900, margin: '0 0 2px 0' }}>Join Our Wellness Community</h3>
              <p style={{ fontSize: '13px', opacity: 0.9, margin: 0 }}>Get exclusive offers, wellness tips & the latest updates.</p>
            </div>
          </div>

          {subscribed ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', background: 'rgba(0, 0, 0, 0.3)', padding: '10px 20px', borderRadius: '9999px', fontSize: '13.5px', fontWeight: 800 }}>
              <CheckCircle2 size={18} color="#4ade80" />
              <span>Thank you for joining our community!</span>
            </div>
          ) : (
            <form onSubmit={handleSubscribe} style={{ display: 'flex', gap: '8px', flex: 1, maxWidth: '480px', flexWrap: 'wrap', width: '100%' }}>
              <input
                type="email"
                required
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{ flex: '1 1 220px', padding: '12px 18px', borderRadius: '10px', border: 'none', fontSize: '13.5px', outline: 'none', background: '#ffffff', color: '#0f172a', minWidth: 0 }}
              />
              <button
                type="submit"
                style={{ background: '#0f172a', color: '#ffffff', border: 'none', borderRadius: '10px', padding: '12px 24px', fontSize: '13.5px', fontWeight: 800, cursor: 'pointer', whiteSpace: 'nowrap' }}
              >
                Subscribe
              </button>
            </form>
          )}

        </div>
      </div>

    </div>
  );
};

export default PreFooter;
